module.exports = "(function() {\r\n    'use strict';\r\n\r\n    angular.module('app.staticemployer', [\r\n        'app.core'\r\n      ]);\r\n})();\r\n"